import axios from "axios";
import { API } from "@/lib/api";

const KEY = "ra_token";
export const academy = axios.create({ baseURL: `${API}/academy` });

export const getAcademyToken = () => localStorage.getItem(KEY);
export function setAcademyToken(t) {
  if (t) localStorage.setItem(KEY, t);
  else localStorage.removeItem(KEY);
}

academy.interceptors.request.use((cfg) => {
  const t = getAcademyToken();
  if (t) cfg.headers["X-Academy-Token"] = t;
  return cfg;
});

export const fmtDuration = (s) => {
  const m = Math.round((s || 0) / 60);
  if (m < 60) return `${m} min`;
  return `${Math.floor(m / 60)} h ${m % 60} min`;
};

export const FOOTER_NOTICE =
  "Platform menus change often. If a button is named differently, look for the closest match and check the platform's current Help Center. This course is general information, not legal advice.";
export const EMERGENCY_LINE = "In immediate danger? Call 112 (EU emergency number) first.";
export const DISCLAIMER =
  "This course provides general information to help people use online reporting tools. It is not legal advice and does not create a lawyer-client relationship. The Certificate of Completion is not a legal or professional qualification. DSA Specialists is not affiliated with Roblox, Discord, Meta, Aylo or any platform mentioned.";
